import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IDialogError, IErrorSnackBar } from "../models";

@Injectable({
  providedIn: "root",
})
export class MessageService {
  private errorSnackBarSubject = new BehaviorSubject<IErrorSnackBar | null>(
    null
  );
  private errorDialogSubject = new BehaviorSubject<IDialogError | null>(null);

  // Expose observables for subscription
  public readonly errorSnackBar$: Observable<IErrorSnackBar | null> =
    this.errorSnackBarSubject.asObservable();
  public readonly errorDialog$: Observable<IDialogError | null> =
    this.errorDialogSubject.asObservable();

  /**
   * Display a snackbar error message.
   * @param error - The error details to display.
   */
  displayErrorMessage(error: IErrorSnackBar): void {
    this.errorSnackBarSubject.next(error);
  }

  /**
   * Clear the snackbar error message (e.g., on route change).
   */
  clearErrorMessage(): void {
    this.errorSnackBarSubject.next(null);
  }

  /**
   * Display an error dialog.
   * @param error - The error details to display in the dialog.
   */
  displayErrorDialog(error: IDialogError): void {
    this.errorDialogSubject.next(error);
  }

  /**
   * Clear the error dialog.
   */
  clearErrorDialog(): void {
    this.errorDialogSubject.next(null);
  }
}
